export class AdbConnectSupport {

  get connected() {
    return true
  }

  async connect() {

  }

  async disconnect() {

  }

  async downloadFiles(onDownloadFile) {
    let count = 0;
    count += await this._downloadFiles(1, "/userdata/offlineData/", "/userdata/", onDownloadFile);
    count += await this._downloadFiles(2, "/userdata/videos/data/", "/userdata/videos/", onDownloadFile);

    return count;
  }

  async

  async _downloadFiles(type, jsonPath, filePath, onDownloadFile) {

  }

  async _parseJson(type, params, file, onDownloadFile) {
    if (type === 1) {
      const json = params['params'];
      if (json.sealTime) {
        json.sealTime = json.sealTime.replace('.', '-')
      }
      await onDownloadFile?.({
        type: "image",
        json: JSON.stringify(json),
        file: file
      })
      params = {nodeVideoUploadJson: JSON.stringify(params['params'])}
      if (json.sealTime) {
        json.sealTime = json.sealTime.replace('.', '-')
      }
      if (params?.json?.params?.type != null) {
        params.json.params.type = null
      }
    } else {
      if (params['split_points'] == true) {
        await onDownloadFile?.({
          split_points: true,
          type: "video",
          json: JSON.stringify({
            baseStation: params['baseStation'],
            businessKey: params['businessKey'],
            coverId: params['params']['coverId'],
            documentId: params['params']['documentId'],
            finishLeftTimes: params['params']['over_usedtimes'],
            finishTime: params['params']['overtime'],
            sealId: params['params']['sealId'],
            staffId: params['params']['staffId'],
            startLeftTimes: params['params']['start_usedtimes'],
            startTime: params['params']['begintime'],
            documentVideoNodeRelList: params['point_record']
          }),
          needConvertVideo: true,
          file: file
        });
      } else {
        await onDownloadFile?.({
          split_points: false,
          type: "video",
          json: {
            businessKey: params['businessKey'],
            staffId: params['params']['staffId'],
            sealId: params['params']['sealId'],
            documentId: params['params']['documentId'],
            file: file
          }
        });
      }
    }
  }

  async firmwareUpgrade(data) {
    let url = data.fullFirmwareLink
    const filename = 'upgrade.tar.gz';
    let filePth = "/oem/firmware_version_up/";
    let file;

    const fun = async (type, onProgress) => {
      if (type === 1) {
        file = await this._downloadFile(url, filename, onProgress);
      } else if (type === 2) {
        await this._pushFile(filePth, file, onProgress)
      }
    }

    return {
      localCallback: fun,
      path: this.connected ? filename : null
    }
  }

  async imageUpgrade(data) {
    let url = data.fullFirmwareLink
    const filename = `${data.edition}.img`;
    let filePth = "/userdata/ota_update/";
    let file;

    const fun = async (type, onProgress) => {
      if (type === 1) {
        file = await this._downloadFile(url, filename, onProgress);
      } else if (type === 2) {
        await this._pushFile(filePth, file, onProgress)
      }
    }

    return {
      localCallback: fun,
      path: this.connected ? filename : null
    }
  }

  async _downloadFile(url, filename, onProgress) {

  }

  async _pushFile(filePath, file, onProgress) {

  }

  isSupport() {

  }
}

export class CompositeAdbConnectSupport extends AdbConnectSupport {
  /**
   * @type {AdbConnectSupport[]}
   */
  adbConnectSupports = []

  /**
   * @type{AdbConnectSupport}
   * @private
   */
  _adbConnectSupport;

  get connected() {
    return this._adbConnectSupport ? this._adbConnectSupport.connected : false;
  }

  async connect() {
    for (const i in this.adbConnectSupports) {
      const adbConnectSupport = this.adbConnectSupports[i];

      if (adbConnectSupport.isSupport()) {
        await adbConnectSupport.connect();
        this._adbConnectSupport = adbConnectSupport;
        return;
      }
    }


  }

  async disconnect() {
    return this._adbConnectSupport?.disconnect();
  }

  async downloadFiles(onDownloadFile) {
    return this._adbConnectSupport?.downloadFiles(onDownloadFile);
  }

  async firmwareUpgrade(data) {
    return this._adbConnectSupport?.firmwareUpgrade(data);
  }

  async imageUpgrade(data) {
    return this._adbConnectSupport?.imageUpgrade(data);
  }

  isSupport() {
    for (const i in this.adbConnectSupports) {
      const adbConnectSupport = this.adbConnectSupports[i];
      if (adbConnectSupport.isSupport()) {
        return true;
      }
    }

    return false;
  }
}

export const compositeAdbConnectSupport = new CompositeAdbConnectSupport();